import { TApiSuccessCallback, TApiErrorCallback, TMultiCallParam } from "./api.interfaces";
import { CancelablePromise as Promise } from "./cancelablePromise";
import Api from "../services/api";

interface IApiCall {
    method: string;
    params: any;
    successCallback: TApiSuccessCallback;
    errorCallback: TApiErrorCallback;
}

export default class MultiCall {
    protected api: Api;
    protected calls: IApiCall[] = [];

    constructor(api: Api) {
        this.api = api;
    }

    add(method: string, params: any, successCallback?: TApiSuccessCallback, errorCallback?: TApiErrorCallback) {
        this.calls.push({
            method: method,
            params: params,
            successCallback: successCallback || this.noOp,
            errorCallback: errorCallback || this.noOp
        });
    }

    getLength(): number {
        return this.calls.length;
    }

    getFailedCall(requestIndex: number) {
        return this.calls[requestIndex];
    }

    beginInvoke(): Promise {
        return new Promise((resolve, reject) => {
            let callsArray: TMultiCallParam[] = this.calls.map(call => [call.method, call.params]);

            if (callsArray.length > 0) {
                this.api.multiCall(callsArray, (results) => {
                    let callResults: any[] = [];
                    this.calls.forEach(function(call, index) {
                        let callResult = results[index] || null;
                        call.successCallback(callResult);
                        callResults.push(callResult);
                    });

                    resolve(callResults);
                }, (errorObject) => {
                    this.calls.forEach(function(call) {
                        call.errorCallback(errorObject);
                    });

                    reject(errorObject);
                });
            } else {
                resolve([]);
            }
        });
    }

    protected noOp(this: void, arg) {
        return arg;
    }
}